var _Path, _Path2, _Path3, _Defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 53 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    clipPath: "url(#arrow-up_svg__clip0)",
    fill: props.fill
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M25 63h4a3 3 0 003-3V16a3 3 0 00-3-3h-4a3 3 0 00-3 3v44a3 3 0 003 3z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M24.715 2.887l-2.828 2.829a3 3 0 000 4.242l21.92 21.92a3 3 0 004.243 0l2.828-2.828a3 3 0 000-4.242l-21.92-21.92a3 3 0 00-4.243 0z"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    d: "M31.787 5.716l-2.829-2.829a3 3 0 00-4.242 0l-21.92 21.92a3 3 0 000 4.243l2.828 2.829a3 3 0 004.242 0l21.92-21.92a3 3 0 000-4.243z"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(ClipPath, {
    id: "arrow-up_svg__clip0"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    transform: "rotate(-180 26.5 31.5)",
    d: "M0 0h53v63H0z"
  })))));
}

export default SvgArrowUp;